// Function loadVideoBlock loads the VideoBlock class by dynamically importing the js on demand if needed

export function loadShopVideoBlock($parentEl, isList = false) {

	let $wg = $parentEl.querySelector('[data-wg="ShopVideoBlock"]');

	if(!$wg) {
		// console.info('ShopVideoBlock: no widget found');
		return Promise.reject('ShopVideoBlock widget not found in the parent element');
	}

	return import(/* webpackChunkName: "wg-shop-video-block-chunk" */ '../widgets/ShopVideoBlock').then(wg => {

		const { ShopVideoBlock } = wg;

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="ShopVideoBlock"]');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new ShopVideoBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new ShopVideoBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the ShopVideoBlock widget');

}
